
import React from "react";
import {
  Card,
  Container,
  Row,
  Col,
 } from "react-bootstrap";

 import logoCorporacion from "assets/img/logo.png";

function Inicio(Usuario) {
 
    return (
      <>
        <Container fluid>
          
        <Row>
            <Col md="12">
              <Card className="strpied-tabled-with-hover">
                <Card.Header>
                  <Card.Title as="h4" style={{ textAlign: "center" }}>Bienvenida al sistema de gestión de la información de la Comunidad Tesi Huneeus</Card.Title>
                  <p className="card-category">
                    <br></br>
                                </p>
                </Card.Header>
                <Card.Body className="table-full-width table-responsive px-0">
               
                <img
                src={logoCorporacion}
                alt="..."
                width="30%" 
                height="auto"
                style={{ display: "block", margin: "0 auto" }}
               
              />
              <br></br>
        
                </Card.Body>
              </Card>
            </Col>
        </Row>
        
        </Container>
      </>
    );
  
  
}

export default Inicio;
